/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * 사용자의 알람 목록을 조회합니다.
 * @summary 알람 목록 조회
 */
export const notificationsControllerGetNotificationsQueryPageDefault = 1;

export const notificationsControllerGetNotificationsQueryLimitDefault = 20;
export const notificationsControllerGetNotificationsQueryLimitMax = 100;

export const notificationsControllerGetNotificationsQuerySortByDefault =
  "created_at";
export const notificationsControllerGetNotificationsQuerySortOrderDefault =
  "desc";

export const notificationsControllerGetNotificationsQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(notificationsControllerGetNotificationsQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(notificationsControllerGetNotificationsQueryLimitMax)
      .default(notificationsControllerGetNotificationsQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod.coerce
      .string()
      .default(notificationsControllerGetNotificationsQuerySortByDefault)
      .describe("정렬 필드"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(notificationsControllerGetNotificationsQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    category: zod
      .enum(["system", "project", "chat", "payment", "review"])
      .optional()
      .describe("알람 카테고리 필터"),
    isRead: zod.coerce.boolean().optional().describe("읽음 상태 필터"),
  })
  .strict();

export const notificationsControllerGetNotificationsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("알람 ID"),
              type: zod
                .enum([
                  "quote_request_created",
                  "quote_response_received",
                  "quote_deadline_approaching",
                  "payment_received",
                  "payment_expired",
                  "cancellation_requested",
                  "contract_cancellation_approved",
                  "refund_completed",
                  "supplier_selected",
                  "contract_completed",
                  "purchase_confirmed",
                  "contract_documents_ready",
                  "contract_restriction_flagged",
                  "review_requested",
                  "review_completed",
                  "new_message_received",
                  "chat_message_unanswered",
                  "chat_reply_delayed",
                  "user_signed_up",
                  "subscription_upgraded",
                  "subscription_payment_success",
                  "subscription_payment_failed",
                  "subscription_expiring_soon",
                ])
                .describe("알람 타입"),
              category: zod
                .enum(["system", "project", "chat", "payment", "review"])
                .describe("알람 카테고리"),
              title: zod.string().describe("알람 제목"),
              message: zod.string().describe("알람 메시지"),
              resourceId: zod.string().optional().describe("연결된 리소스 ID"),
              resourceType: zod
                .string()
                .optional()
                .describe(
                  "Resource type for frontend navigation (quote_request, quote_response, chat_room, etc.)",
                ),
              isRead: zod.boolean().describe("읽음 여부"),
              readAt: zod
                .string()
                .optional()
                .describe("읽음 처리 시각 (ISO 8601)"),
              createdAt: zod.string().describe("알람 생성 시각 (ISO 8601)"),
              metadata: zod.object({}).optional().describe("내부 메타데이터"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 읽지 않은 알람 개수 조회
 */
export const notificationsControllerGetUnreadCountResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        count: zod.number().describe("읽지 않은 알람 총 개수 (시스템 + 채팅)"),
        notificationCount: zod.number().describe("읽지 않은 시스템 알림 개수"),
        chatCount: zod.number().describe("읽지 않은 채팅 메시지 개수"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 전체 알람 읽음 처리
 */
export const notificationsControllerMarkAllAsReadBody = zod.object({}).strict();

export const notificationsControllerMarkAllAsReadResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean().describe("처리 성공 여부"),
        message: zod.string().describe("처리 메시지"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 알람 읽음 처리
 */
export const notificationsControllerMarkAsReadParams = zod
  .object({
    id: zod.coerce.string().describe("알람 ID (UUID)"),
  })
  .strict();

export const notificationsControllerMarkAsReadResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        success: zod.boolean().describe("처리 성공 여부"),
        notificationId: zod.string().describe("처리된 알람 ID"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 알림 구독 정보 조회
 */
export const notificationsControllerGetSubscriptionInfoResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        apiVersion: zod.string().describe("API 버전"),
        user: zod
          .object({
            id: zod.string().describe("사용자 ID (public.users.id)"),
            unreadCount: zod.number().describe("읽지 않은 알림 개수"),
          })
          .strict()
          .describe("사용자 정보"),
        channels: zod
          .array(
            zod
              .object({
                type: zod.enum(["realtime"]).describe("채널 타입"),
                channelName: zod.string().describe("Supabase Realtime 채널명"),
                events: zod
                  .array(zod.string())
                  .describe("수신 가능한 이벤트 목록"),
                connectionInfo: zod
                  .object({
                    provider: zod.string().describe("연결 제공자"),
                    projectRef: zod
                      .string()
                      .optional()
                      .describe("Supabase 프로젝트 참조 (선택)"),
                  })
                  .strict()
                  .describe("연결 정보"),
              })
              .strict(),
          )
          .describe(
            "구독 채널 목록 (현재 realtime만 지원, 향후 email/kakao/webhook 확장 가능)",
          ),
        settings: zod
          .object({
            system: zod
              .boolean()
              .describe("시스템 알림 활성화 (공지사항, 점검 등)"),
            project: zod.boolean().describe("프로젝트 알림 활성화"),
            chat: zod.boolean().describe("채팅 알림 활성화"),
            payment: zod.boolean().describe("결제 알림 활성화"),
            review: zod.boolean().describe("리뷰 알림 활성화"),
            updatedAt: zod.string().describe("설정 마지막 수정일 (ISO 8601)"),
          })
          .strict()
          .describe(
            "카테고리별 알림 설정 (user_notification_settings 테이블 기반)",
          ),
        meta: zod
          .object({
            serverTime: zod.string().describe("서버 시간 (ISO 8601)"),
            ttlSeconds: zod.number().describe("캐시 권장 시간 (초)"),
          })
          .strict()
          .describe("메타 정보"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary Subscribe to push notifications
 */
export const pushNotificationControllerSubscribeHeader = zod
  .object({
    "user-agent": zod.string(),
  })
  .strict();

export const pushNotificationControllerSubscribeBody = zod
  .object({
    endpoint: zod.string(),
    keys: zod
      .object({
        p256dh: zod.string(),
        auth: zod.string(),
      })
      .strict(),
    expirationTime: zod.number().nullish(),
  })
  .strict();

/**
 * @summary Unsubscribe from push notifications
 */
export const pushNotificationControllerUnsubscribeBody = zod
  .object({
    endpoint: zod.string(),
  })
  .strict();
